
const StorySection = () => {
  return (
    <section className="py-32 bg-gradient-to-b from-slate-800/30 to-slate-900/30 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-600/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-cyan-600/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative container mx-auto px-6 max-w-7xl">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div className="inline-block mb-4">
              <span className="px-4 py-2 bg-blue-600/20 text-blue-300 rounded-full text-sm font-medium border border-blue-400/30">
                Our Journey
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-light text-white mb-8 leading-tight">
              Our <strong className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">Story</strong>
            </h2>
            <div className="space-y-6 text-white/80 leading-relaxed font-light text-lg">
              <p>
                Founded in 2015, Sentronics Solution Limited emerged from a vision to connect 
                global technology ecosystems. Headquartered in Hong Kong, we strategically position 
                ourselves at the crossroads of East and West, facilitating seamless innovation transfer.
              </p>
              <p>
                Over the years, we've evolved from a technology transfer facilitator to a 
                comprehensive R&D and OEM customization partner, serving clients across Europe, 
                North America, and Asia-Pacific regions with cutting-edge solutions.
              </p>
              <p>
                Our journey has been marked by continuous innovation, strategic partnerships, 
                and an unwavering commitment to delivering excellence in every project we undertake, 
                building lasting relationships that drive mutual success.
              </p>
            </div>
          </div>
          
          <div className="relative group">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-cyan-600/20 rounded-3xl blur-2xl group-hover:blur-3xl transition-all duration-500"></div>
            <div className="relative overflow-hidden rounded-3xl border border-white/20 group-hover:border-blue-400/40 transition-all duration-500">
              <img
                src="https://public.readdy.ai/ai/img_res/9c480ec7e7d19ac59ae1dfa33a407cc1.jpg"
                alt="Our Story"
                className="w-full h-[500px] object-cover object-top transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute inset-0 bg-gradient-to-r from-blue-600/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StorySection;
